import React from 'react'
import Icon from './Icon'

const GroupIcon = (props) => <Icon icon="fa fa-users" {...props} />

export default GroupIcon
